import { customAlphabet } from 'nanoid'

export const shortenAddress = (address: string, chars = 4) => {
    if (address.length < chars) return '0xMissing address'
    return `${address.slice(0, chars + 2)}...${address.slice(-chars)}`
}

export const cleanOutput = (output: string | number, defaultOutput = '-'): string => {
    const strOutput = String(output).replaceAll('~', '').replaceAll(' ', '')
    if (strOutput === '0') return defaultOutput
    if (strOutput === '0%') return defaultOutput
    if (strOutput === '0$') return defaultOutput
    if (strOutput === '0k$') return defaultOutput
    if (strOutput === '0m$') return defaultOutput
    if (strOutput === 'NaN') return defaultOutput
    return String(output)
}

export const formatId = (id: string) => {
    return id
        .replace(/\s/g, '-')
        .replace(/[^a-zA-Z0-9_-]/g, '')
        .toLowerCase()
}

export const generateSlug = (value: string) => {
    const id = customAlphabet('1234567890abcdef', 10)
    return [formatId(value), id(4)].join('-')
}

export const getNameFromEmail = (email: string) => {
    return email.split('@')[0].split('+')[0]
}

export const getDomainFromEmail = (email: string) => {
    return email.split('@')[1]
}

export const slugify = (text: string) => {
    return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/[^\w-]+/g, '') // Remove all non-word chars
        .replace(/--+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text
}
